import React from 'react';
import { withRouter } from 'react-router-dom';
import { Howl } from 'howler';
import ChatBot from '../ChatBot/ChatBot';
import { genSpeechGestures, amiraGestures } from './GesturedSpeech';
import { spine } from "./../../spine-webgl";
import { WEBGL_ASSET_PATHS, gameSFXKeys } from '../../constants/constants';
import { DANCE_TITLES } from "../../services/badging/constants";
import { getUserData } from "../../services/API";
import { logSentryException, shouldForceHTML5Audio, iOSSupportsAudioSession } from '../../services/util';
import * as Sentry from '@sentry/browser';

/** home app section */
// songs for dances
const funkyChickenSong = require('./assets/sounds/dances/Chicken.wav');
const flossSong = require('./assets/sounds/dances/Floss.wav');
const renegadeSong = require('./assets/sounds/dances/Renedgade.wav');
/** home app section end */

/** home app section */
var animationJson;
var visemeArray = [];
let gestureArray = [];
/** home app section end */

let speaking = false;
let speechTimeout = null;

/** home app section */
let media = null;
let speechPropsArray = [];
let mounted = false;

let timer;  //for readaloud timer
let time;   //for readaloud time within the timer to reset between sentences
let manualStopTimer; // for catching instances where status === 4 is not called
let mediaDurationTimer; // to prevent androids from not being able to get duration

let amiraAvatar = {
  name: 'amira',
  scale: getUserData().sessionData.isPhone ? new spine.Vector2(0.9, 0.9) : new spine.Vector2(0.51, 0.51),
  spineContent: null,
  pos: null,
};

export const DANCES = [
  {
    title: DANCE_TITLES.CHICKEN,
    audioUrl: funkyChickenSong,
    gesture: amiraGestures.TheFunkyChicken,
  },
  {
    audioUrl: "renegadeSong",
    gesture: amiraGestures.TheRenegadeDance,
  },
  {
    title: DANCE_TITLES.RENEGADE,
    audioUrl: renegadeSong,
    gesture: amiraGestures.TheRenegadeDance,
  },
  {
    title: DANCE_TITLES.FLOSS,
    audioUrl: flossSong,
    gesture: amiraGestures.TheFlossDance,
  },
];
/** home app section end */

class Coach extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      source: "Lexa",
      postMessageData: "Init",
      passThroughSpeech: false,         //If this name changes, must change Sumerian too (so don't do it)
      audioURL: null,
      isHidden: false, // home app
    };

    amiraAvatar.scale = new spine.Vector2(window.innerHeight/1000, window.innerHeight/1000); // home app

    this.speak = this.speak.bind(this);
    this.onReceiveMessage = this.onReceiveMessage.bind(this);
    this.onAbortPlaying = this.onAbortPlaying.bind(this);
    this.onFinishedPlaying = this.onFinishedPlaying.bind(this);
    this.speechEndCallback = this.speechEndCallback.bind(this);
    this.speechStartCallback = this.speechStartCallback.bind(this);
    this.abortSpeech = this.abortSpeech.bind(this);
    /** home app secontion */
    this.onUtteranceStart = this.onUtteranceStart.bind(this);
    this.onWordEnd = this.onWordEnd.bind(this);
    this.onSpeaking = this.onSpeaking.bind(this);
    this.playSpeech = this.playSpeech.bind(this);

    /** home app secontion end */
    this.renderAmira = this.renderAmira.bind(this)
  }

  speechEndCallback(speechObj) {
    //LEAVE IN FOR DEBUG
    //console.log("ON SPEECH END FIRED:", Date.now());
    if (speechObj && speechObj.onEnd && mounted) {
      speechObj.onEnd();
    }
  }

  speechStartCallback(speechObj) {
    if (speechObj.onStart) speechObj.onStart();
    speaking = true;
    speechTimeout && window.clearTimeout(speechTimeout);
  }

  registerAbortHandler(prevProps) {
    if (prevProps.speech && !prevProps.speech.setAbortSpeech && this.props.speech.setAbortSpeech) {
      this.props.speech.setAbortSpeech(this.abortSpeech);
    }
    if (prevProps.speech && !prevProps.speech.setAbortDance && this.props.speech.setAbortDance) {
      this.props.speech.setAbortDance(this.abortDance);
    }
  }

  /** home app section */
  componentDidMount() {
    mounted = true;
    this.props.speech.setAbortSpeech(this.abortSpeech.bind(this));
    this.props.speech.setAbortDance(this.abortDance.bind(this));
    this.props.setCoachReady(true);
    this.setState({isHidden: this.props.isHidden});
    console.log("COACH", this.props.history)

    if(!this.props.isHidden){
      this.renderAmira()
    }else{
      this.props.webglProps.stopAnimation()
    }
  }
  /** home app section end */
  renderAmira(){
    const realToCSSPixels = window.devicePixelRatio;
    const amiraSkeletonData = this.props.webglProps.loadSkeletonData(WEBGL_ASSET_PATHS.AMIRA_PATH + ".skel", WEBGL_ASSET_PATHS.AMIRA_PATH + ".atlas");
    amiraAvatar.spineContent = this.props.webglProps.createSpineInstance(amiraSkeletonData, "visemes/viseme_sil", "amira", "default");

    let scale = 0.70
    const aspect = window.innerHeight / window.innerWidth
    const isiPadRatio = aspect >= 0.62
    const isLowResScreen = realToCSSPixels < 2

    // this positioning parameters are fixed values because the canvas is a fixed size.
    let posX = 1650
    let posY = 340

    if(!isiPadRatio){
      // adjust the Y position for Chromebook zoomed settings.
      if(isLowResScreen) posY = posY / realToCSSPixels
    }

    amiraAvatar.pos = new spine.Vector2(posX, posY);
    amiraAvatar.scale = new spine.Vector2(scale, scale)

    if (!this.props.isHidden) {
      this.props.webglProps.sendSpineRenderable(amiraAvatar);
    }
  }

  componentDidUpdate(prevProps){
    this.registerAbortHandler(prevProps);

    // If the isHidden prop has changed
    if(this.props.isHidden !== this.state.isHidden) {
      // If it is changing from true to false, reanimate amira
      if (!this.props.isHidden && this.state.isHidden) {
        visemeArray = [];
        gestureArray = [];
        this.props.webglProps.sendAmiraVisemeArray(visemeArray);
        this.props.webglProps.sendAmiraGestureArray(gestureArray);
        this.props.webglProps.sendSpineRenderable(amiraAvatar);
        console.log("componentDidUpdate Coach", prevProps)
        this.props.webglProps.moveWebglLayer('highestZ');
      } else {
        this.props.webglProps.removeSpineRenderable(amiraAvatar);
      }
      // Update state
      this.setState({isHidden: this.props.isHidden});
    }

    // TODO: Move in the functionality of speaking from LexaSpeech to here
    if (this.props.message.id !== prevProps.message.id) {
      if ((this.props.message.skipAvatar) || (this.props.config.useSumerian == false)) {
        this.speak(this.props.message, true);
      } else {
        this.speak(this.props.message, false);
      }
    }

    // If the coach has received new speech marks and audio to say
    if (this.props.avatarSpeechProps.speech_marks) {
      if (!animationJson || this.props.avatarSpeechProps.id !== prevProps.avatarSpeechProps.id) {
        // Set the animation json and load the visemes and gestures
        animationJson = this.props.avatarSpeechProps.speech_marks;
        this.playSpeech(this.props.avatarSpeechProps);
      }
    }

    if(this.props.avatarSpeechProps.dance
        &&  (!prevProps.avatarSpeechProps.dance
            || (this.props.avatarSpeechProps.dance.gesture != prevProps.avatarSpeechProps.dance.gesture))) {
      this.playDance();
    }

    if (((!prevProps.avatarSpeechProps && this.props.avatarSpeechProps) || (this.props.avatarSpeechProps.id != prevProps.avatarSpeechProps.id)) && (this.props.config.useSumerian == true)) {
      let passThrough = false;
      if (this.props.avatarSpeechProps.passThroughSpeechTags) {
        passThrough = true;
      }

    }
  }

  /** home app section */
  componentWillUnmount() {
    // Set mounted variable and clear timer and media objects
    mounted = false;
    if (timer) {
      clearInterval(timer);
      timer = null;
    }
    if (mediaDurationTimer) {
      clearTimeout(mediaDurationTimer);
      mediaDurationTimer = null;
    }
    if (manualStopTimer) {
      clearTimeout(manualStopTimer);
      manualStopTimer = null;
    }
    if (media) {
      this.destroyMedia();
      this.onFinishedPlaying();
    }

    this.props.webglProps.removeSpineRenderable(amiraAvatar);

    animationJson = null;
    visemeArray = [];
    gestureArray = [];
  }
  /** home app section end */

  destroyMedia(){
    if (media) {
      media.off();
      media.stop();
      media.unload();
      media = null;
    }
  }

  /** home app section */
  async playSpeech(nextSpeech) {
    // Prepare animations
    this.loadVisemes();
    this.loadGestures();

    if(nextSpeech.active) return;

    nextSpeech.active = true;
    speechPropsArray.push(nextSpeech);

    time = Date.now();
    const setOnSpeakingTimer = (audioStopped = false) => {
      if (timer) {
        clearInterval(timer);
      }
      timer = setInterval(() => {
        let now = Date.now();
        let timeAfter = now - time;

        if (audioStopped) {
          time = Date.now();
          clearInterval(timer);
        }

        this.onSpeaking(timeAfter)
      }, 32)
    }

    // Start the audio
    const playMedia = speechObj => {
      if (speechObj && !speechObj.aborted) {
        speaking = true;
        this.props.webglProps.sendAmiraVisemeArray(visemeArray);
        this.props.webglProps.sendAmiraGestureArray(gestureArray);
        speechObj.media.play();
      }
    }

    // On audio play callback
    const onPlay = speechObj => {
      console.log('playing speech... onPlay')
      this.props.webglProps.resetAmiraAnimations();
      this.props.webglProps.setAmiraPlayAnimations(true);
      speechObj.playing = true;
      this.onUtteranceStart(speechObj);
    }

    // On audio end callback
    const onEnd = speechObj => {
      console.log('playing speech... onEnd');
      speaking = false;
      speechObj.playing = false;
      if(!speechObj.aborted){
        this.onFinishedPlaying(speechObj);
        this.destroyMedia();
      }
    }

    // Audio audio error callback
    const onError = (error, speechObj) => {
      console.error('Error coach:', error);
      if(!speechObj.aborted){
        this.onFinishedPlaying(speechObj);
        this.destroyMedia();
      }
    }

    try{
      if(media){
        this.destroyMedia();
      }
      if (iOSSupportsAudioSession()) {
        navigator.audioSession.type = 'playback';
      }
      media = new Howl({
        src: [this.props.avatarSpeechProps.audioURL],
        format: ['mp3'],
        volume: 0.5,
        html5: shouldForceHTML5Audio(),
        pool: 5,
        onloaderror: (id, error) => {
          console.error('Sound on load error:', error);
          logSentryException(error, "Sound on load error");
          onError(error, nextSpeech);
        },
        onplayerror: (id, error) => {
          console.error('Sound on play error:', error);
          logSentryException(error, "Sound on play error");
          this.setState({
            audioLocked: true
          })
          if(sound){
            sound.once('unlock', function() {
              console.log("Auto unlocked and continued to play")
              playMedia(nextSpeech);
            });
          }
        },
        onload: () => playMedia(nextSpeech),
        onplay: () => {
          setOnSpeakingTimer();
          onPlay(nextSpeech);
        },
        onstop: () => {
          const audioStopped = true;
          setOnSpeakingTimer(audioStopped);
          onEnd(nextSpeech);
        },
        onend: () => {
          const audioStopped = true;
          setOnSpeakingTimer(audioStopped);
          onEnd(nextSpeech);
        }
      });
    }catch(e){
      console.error("Error creating new Howl", e)
      logSentryException(e, "Error creating new Howl");
    }

      nextSpeech.media = media;
  }

  /** home app section */
  abortDance(){
    amiraAvatar.spineContent.state.setAnimation(2, "gestures/Idle", false);
    this.props.webglProps.resetAmiraAnimations();
  }
  /** home app section end */

  /** home app section */
  playDance() {
    let dance = this.props.avatarSpeechProps.dance;

    let playDanceGesture = (onDanceEnd) => {
      const trackEntry = amiraAvatar.spineContent.state.setAnimation(3, "gestures/" + dance.gesture, false);
      const durationMs = Math.floor(trackEntry.animation.duration * 1000);
      if(this.props.avatarSpeechProps.onDanceStart){
        this.props.avatarSpeechProps.onDanceStart();
      }
      if(onDanceEnd){
        setTimeout(()=> {
          onDanceEnd();
          this.abortDance()
        }, durationMs)
      }
      return trackEntry;
    }

    this.props.webglProps.sendAmiraGestureArray(gestureArray);
    if(dance.audioUrl) {
      this.props.speech.playAppSounds({
        url: dance.audioUrl,
        onfinish: this.onFinishedPlaying.bind(this),
        onStart: e => playDanceGesture(this.props.avatarSpeechProps.onDanceEnd),
        volume: '0.10',
        key: gameSFXKeys.danceMusic,
      });
    } else {
      // IF we have no audioUrl that means we only want to play the animation/gesture
      // so no need to call `onFinishedPlaying` since we have no media to release.
      return playDanceGesture(this.props.avatarSpeechProps.onDanceEnd);
    }
  }
  /** home app section end */

  /** home app section */
  onWordEnd(word) {
    if (this.props.speech && this.props.avatarSpeechProps.onBoundary) {
      this.props.avatarSpeechProps.onBoundary(word);
    }
  }
  /** home app section end */

  /** home app section */
  onSpeaking(position) {
    let index = 0;
    let aSpeechMarks = this.props.avatarSpeechProps.speech_marks;

    if (aSpeechMarks && position) {
      aSpeechMarks.forEach(sentence => {
        sentence.words.forEach(word => {

          if (word.time && (word.time <= position) && !(word.value.includes("<") && word.value.includes(">"))) {
            word.start = index; //Override the start character with the word index
            this.onWordEnd(word);
            word.time = null;    //Do this so the word isn't evaluated again
            if (mounted) {
              this.setState({ speech_marks: aSpeechMarks });
            }
          }
          if (!(word.value.includes("<") && word.value.includes(">"))) index++;
        });
      });
    }
  }
  /** home app section end */

  /** home app section */
  onUtteranceStart(speechObj) {
    if (speechObj && speechObj.onStart && !speechObj.aborted) {
      speechObj.onStart();
    }
  }
  /** home app section end */

  async abortSpeech(abortCallback) {
    //console.log('COACH- abort speech');
    for (const s of speechPropsArray) {
      s.aborted = true;
      if(s.media && s.playing) {
        this.destroyMedia();
      }
      await this.onAbortPlaying(s);
    }

    if(speaking){
      if (!this.props.isHidden) {
        visemeArray = [];
        gestureArray = [];
        this.props.webglProps.sendAmiraVisemeArray(visemeArray);
        this.props.webglProps.sendAmiraGestureArray(gestureArray);
        this.props.webglProps.setAmiraPlayAnimations(false);
        this.props.webglProps.resetAmiraAnimations();
      }
      speaking = false;
    }

    abortCallback && await abortCallback();
  }

  speak(message, skipAvatar) {
    let props = {};
    props.textToSpeak = message.pronunciation;

    if (!skipAvatar) {
      let textToSpeak = message.pronunciation || "";
      textToSpeak = genSpeechGestures(textToSpeak, "en") || "";
      //LEAVE IN FOR DEBUG console.log("Speaking:",textToSpeak);
      if (!textToSpeak.includes("<speak>")) {
        textToSpeak = "<speak>" + textToSpeak + "</speak>";
      }

      props.textToSpeak = textToSpeak;
    }

    if (skipAvatar || (this.props.config.useSumerian == false)) props.skipAvatar = skipAvatar;

    //if we have a callback for when the message is done, add it to onEnd
    if(message.callback){
      props.onEnd = message.callback;
    }

    if(message.passThroughSpeechTags) props.passThroughSpeechTags = true;
    this.props.speech.speak(props);
  }

  onReceiveMessage(evt){
    const dataType = {
     SUMERIANREADY: "SumerianReady",
     SPEECHDONE: "SpeechDone",
    };

    if(evt.data == dataType.SUMERIANREADY){
      this.props.setCoachReady(true);
    }
    //Note: IntroSpeechDone
    if(evt.data == dataType.SPEECHDONE && this.props.avatarSpeechProps.onEnd){
      this.props.avatarSpeechProps.onEnd();
    }
    //TODO: Add assessment ready when we bring that in.
  }

  async onAbortPlaying(speechObj) {
    // console.log('COACH, onAbortPlaying', speechObj);
    if(timer){
      clearInterval(timer);
    }

    if(!speechObj) return;
    const { resolveAbort } = speechObj;

    if (resolveAbort) {
      resolveAbort();
    } else {
      console.warn("No resolve abort function found, something could be stuck.");
    }
    speechPropsArray = speechPropsArray.filter(s => s.id != speechObj.id);
  }

  async onFinishedPlaying(speechObj) {
    //console.log('COACH, onFinishedPlaying', speech);
    if(timer){
      clearInterval(timer);
    }
    if (speechObj && !speechObj.aborted) {
      this.speechEndCallback(speechObj);
    }
    if (speechObj) {
      speechPropsArray = speechPropsArray.filter(s => s.id != speechObj.id);
    }
  }

  loadVisemes() {
    visemeArray = [];
    for (const sentence of animationJson) {
      for (const word of sentence.words) {
        if (word.type === 'word') {
          for (const viseme of word.visemes) {
            visemeArray.push(viseme);
          }
        }
      }
    }
  }

  /** home app section */
  loadGestures() {
    gestureArray = [];
    for (const sentence of animationJson) {
      for (const word of sentence.words) {
        if (word.type === 'ssml') {
          let requestedGesture = word.value.replace("gesture:", "");
          if(requestedGesture != amiraGestures.SweepWave) {
            requestedGesture = amiraGestures[requestedGesture] || amiraGestures.Idle;
            word.value = "gestures/" + requestedGesture;
            if(word) {
              gestureArray.push(word);
            }
          }
        }
      }
    }
  }
  /** home app section end */

  render() {
    return (
      <div className="coachContainer">
        <div className="coach">
          {this.props.isCoachReady && this.props.isAppReady && (
            <ChatBot
              speech={this.props.speech}
              transcript={!this.props.isReaderActive ? this.props.transcript : {}} //Only pass transcript when Reader is not listening
              isReaderActive={this.props.isReaderActive}
              muteReader={this.props.muteReader}
              unMuteReader={this.props.unMuteReader} />
          )}
        </div>
      </div>
    );
  }
}

export default withRouter(Coach);
